module.exports = __webpack_public_path__ + "static/media/10.6ba6e4a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/10.svg
// module id = 134
// module chunks = 0